import { i_axios, t_axios, c_axios, g_axios } from './AxiosConfig';
import { WprHttpErrorInfo } from '../../wpr-framework/service/WprHttpErrorInfo';
import { ErrorInfo } from '../../models/ErrorInfo';
import { Agent } from 'https';
import Cookie from 'cookie';
import { AxiosResponse } from 'axios';
const https = require('https');

/**
 * HTTPユーティリティ
 */
export class HttpUtils {
	// 定数  --------------------------------------------------------------------
	/** Result Status */
	public static readonly SERVICE_SUCCESS_STATUS: string 	= '0000';
	public static readonly SERVICE_ERROR_STATUS: string 	= '9000';
	public static readonly API_SUCCESS_STATUS: number 		= 200;
	// --------------------------------------------------------------------------

	// public static メソッド  ---------------------------------------------------
	
	/**
	 * POST通信処理
	 * @param url  
	 * @param request 
	 */
	public static doPost(url: string, request: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const reqJson: string = JSON.stringify(request);
			let resJson: any = null;
			const axiosRes = i_axios.post(url, reqJson);
			Promise.all([axiosRes]).then((result) => {
				resJson = JSON.stringify(result[0].data);
				const convertedRes = JSON.parse(resJson);
				if (this.SERVICE_SUCCESS_STATUS != convertedRes.status) {
					reject(new WprHttpErrorInfo(url, convertedRes.message));
				}
				resolve(convertedRes);
			}).catch((error) => {
				if (error.response) {
					reject(new WprHttpErrorInfo(url, error.response.data.message, error));
				}
				reject(new WprHttpErrorInfo(url, 'システムエラーが発生しました。恐れ入りますが、最初からやり直してください。', error));
			});
		});
	}

	public static finish(url: string) {
		return new Promise((resolve) => {
			const axiosRes = i_axios.post(url);
			Promise.all([axiosRes]).then((result) => {
				resolve(result);
			});
		});
	}
	
	/**
	 * POST通信処理(住所検索用)
	 * @param url 
	 * @param reqType 
	 * @param request 
	 */
	public static doPost_t(url: string, request: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const reqJson: string = JSON.stringify(request);
			const httpsAgent = new https.Agent({ rejectUnauthorized: false });
			const axiosRes = t_axios.post(url, reqJson, { httpsAgent });
			Promise.all([axiosRes]).then((result) => {
				// let resStatus = JSON.stringify(result[0].status);
				// let resStatusText = JSON.stringify(result[0].statusText);
				// let resJson = JSON.stringify(result[0].data);
				// const convStatus = JSON.parse(resStatus);
				// const convText = JSON.parse(resStatusText);
				// const convRes = JSON.parse(resJson);
				// if (this.API_SUCCESS_STATUS === convStatus)
				// 	resolve(result);
				// else
				// 	resolve(convRes);
				resolve(result[0]);
			}).catch((error) => {
				// reject(new WprHttpErrorInfo(url, 'POST通信に失敗しました。', error));
				resolve(error);
			});
		});
	}
	
	/**
	 * POST通信処理(MDKToken用)
	 * @param url 
	 * @param reqType 
	 * @param request 
	 */
	public static doPost_c(url: string, request: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const reqJson: string = JSON.stringify(request);
			console.log(process.env.API_MDK_URL);
			const axiosRes = c_axios.post(url, reqJson);
			Promise.all([axiosRes]).then((result) => {
				let resJson = JSON.stringify(result[0].data);
				const convRes = JSON.parse(resJson);
				resolve(convRes);
			}).catch((error) => {
				reject(new WprHttpErrorInfo(url, 'クレジットカード決済に失敗したため、保険契約の手続きを行うことができませんでした。', error));
			});
		});
	}

	public static doGetXmlFile(url: string): Promise<any> {
		return new Promise((resolve) => {
			const axiosRes = g_axios.get(url);
			Promise.all([axiosRes]).then((result) => {
				resolve(result);
			}).catch((error) => {
				resolve(error);
			});
		});
	}
	// --------------------------------------------------------------------------
}